import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { sortFacilitiesByDistance } from '../../../../data/lib/sort';
import FacilitiesListEntry from '../../../../website/components/stateless/FacilitiesListEntry';
import style from './FacilitiesList.scss';
import useLocationManager from '../../../../website/hooks/useLocationManager';
import { calculateDistance } from '../../../../website/widgets/dynamic/FacilitySearchBar/useFacilityManager';
const propTypes = {
  facilities: PropTypes.array.isRequired,
  isEditable: PropTypes.bool,
};

const defaultProps = { isEditable: false };

const FacilitiesList = ({ facilities, isEditable }) => {
  if (!facilities || facilities.length === 0) {
    return <h2>There are no facilities for this client</h2>;
  }
  const { isLocationEnabled, currentLocation } = useLocationManager(true);
  // sort facilities by distance from the user
  const sortedFacilities = sortFacilitiesByDistance(
    facilities.map(x => ({
      ...x,
      distanceFromCurrentUserInMiles: isLocationEnabled
        ? calculateDistance(
          currentLocation.lat,
          currentLocation.lon,
          x.address.latitude,
          x.address.longitude,
        )
        : x.distanceFromCurrentUserInMiles,
    })),
  );

  return (
    <div>
      {sortedFacilities.map((facility, index) => (
        <div key={index}>
          <FacilitiesListEntry
            facility={facility}
            isEditable={isEditable}
            showLocation={isLocationEnabled}
          />
          <hr className={style.border} />
        </div>
      ))}
    </div>
  );
};

FacilitiesList.fragments = {
  facility: gql`
    fragment FacilitiesListFacility on Facility {
      ...FacilitiesListEntryFacility
    }

    ${FacilitiesListEntry.fragments.facility}
  `,
};

FacilitiesList.propTypes = propTypes;
FacilitiesList.defaultProps = defaultProps;

export default FacilitiesList;
